import {Typography} from '@mui/material';
import {t} from 'i18next';
import {Link} from 'react-router-dom';
import navConstants from '../../../../../constants/navConstants';

const stringPath = 'projectCreation.creation.hotLeadBanner.';
interface Props {
  openHotLeadForm?: () => void;
  haveUnsavedChange?: boolean;
}
const HotLeadFormInfoBanner: React.FC<Props> = ({
  openHotLeadForm,
  haveUnsavedChange,
}) => {
  const onLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    openHotLeadForm && openHotLeadForm();
  };

  return (
    <div
      className="hot-lead-form-banner-container"
      data-testid="hot-lead-banner"
    >
      <Typography className="typo-text headline3_size title-label">
        {t(stringPath + 'title')}
      </Typography>
      <Typography className="typo-text subhead4_size description-label">
        {t(stringPath + 'description')}
        <Link
          className="typo-text subhead4_size share-detail-link"
          to={
            haveUnsavedChange ? '#' : navConstants.projectCreation.hotLeadsForm
          }
          onClick={haveUnsavedChange ? onLinkClick : undefined}
        >
          {t(stringPath + 'shareDetailLink')}
        </Link>
      </Typography>
    </div>
  );
};

export default HotLeadFormInfoBanner;
